import {
  GET_CAMPAIGN_ANALYSIS,
  GET_CAMPAIGN_ANALYSIS_SUCCESS,
  GET_CAMPAIGN_ANALYSIS_ERROR,
  GET_PING_DETAILS,
  GET_PING_DETAILS_SUCCESS,
  GET_PING_DETAILS_ERROR,
  EXPORT_CAMPAIGN_ANALYSIS,
  EXPORT_CAMPAIGN_ANALYSIS_SUCCESS,
  EXPORT_CAMPAIGN_ANALYSIS_ERROR,
} from "./actionTypes"

export const getCampaignAnalysis = (campaign_analysis, paginated) => {
  return {
    type: GET_CAMPAIGN_ANALYSIS,
    payload: campaign_analysis,
    paginated: paginated
  }
}

export const getCampaignAnalysisSuccess = (campaign_analysis, meta = {}) => {
  return {
    type: GET_CAMPAIGN_ANALYSIS_SUCCESS,
    payload: campaign_analysis,
    meta,
  }
}

export const getCampaignAnalysisError = error => {
  return {
    type: GET_CAMPAIGN_ANALYSIS_ERROR,
    payload: error,
  }
}

export const getPingDetails = payload => {
  return {
    type: GET_PING_DETAILS,
    payload: payload,
  }
}

export const getPingDetailsSuccess = payload => {
  return {
    type: GET_PING_DETAILS_SUCCESS,
    payload: payload,
  }
}

export const getPingDetailsError = error => {
  return {
    type: GET_PING_DETAILS_ERROR,
    payload: error,
  }
}

export const exportCampaignAnalysis = (productTypeId, queryParams) => {
  return {
    type: EXPORT_CAMPAIGN_ANALYSIS,
    payload: { productTypeId, queryParams },
  }
}

export const exportCampaignAnalysisSuccess = () => {
  return {
    type: EXPORT_CAMPAIGN_ANALYSIS_SUCCESS,
  }
}

export const exportCampaignAnalysisError = error => {
  return {
    type: EXPORT_CAMPAIGN_ANALYSIS_ERROR,
    payload: error,
  }
}
